export const notNullIsNumberValidator = (value: string) =>
  value === '' || isNaN(Number(value));
